import React, { useState, useEffect } from "react";
import MainLayout from "../../components/layout/MainLayout";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";
import Login from "../../app/auth/Login";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { Flowchart } from "../../components/flowChart/Flowchart.tsx";

import { csldata,gsv,stoke } from "../../components/FlowData/KnowladgeGrapgh.js";

function CustomTabPanel({ children, value, index }) {
  return (
    <div hidden={value !== index}>
      {value === index && <div className="">{children}</div>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  padding: theme.spacing(2, 0),
  ...theme.mixins.toolbar,
}));

const StyledButton = styled(Button)(({ theme }) => ({
  backgroundColor: "#2991d6",
  color: "#fff",
  fontWeight: 600,
  textTransform: "none",
  borderRadius: "8px",
  padding: "6px 20px",
  boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
  "&:hover": {
    backgroundColor: "#1f7db5",
  },
}));

const KnowledgeGraph = () => {
  const [data, setData] = useState({
    id: 0,
    label: "GSV",
    children: [
      {
        id: 2,
        label: "Time Series Analysis",
        children: [
          { id: 6, label: "YTD Variance" },
          { id: 7, label: "Month on Month" },
          { id: 8, label: "Statistical Analysis" },
          { id: 9, label: "Rolling Average" },
          { id: 10, label: "CAGR" },
        ],
      },
      {
        id: 3,
        label: "Decomposition Analysis",
        children: [
          { id: 11, label: "Volume- PriceMix" },
          { id: 12, label: "Accounting Mix (% Breakdown)" },
          { id: 13, label: "Product Mix (% Breakdown)" },
          { id: 14, label: "Segment Mix (% Breakdown)" },
        ],
      },
      { id: 1, label: "Benchmarking against internal factors" },
      {
        id: 5,
        label: "Benchmarking with macro- economic factors",
        children: [
          { id: 17, label: "Inflationary Trend" },
          { id: 18, label: "FX Fluctuations and Trend" },
          { id: 19, label: "Sector Growth" },
        ],
      },
      {
        id: 4,
        label: "Benchmarking against competitors",
        children: [
          { id: 15, label: "Advertising & Promotion" },
          { id: 16, label: "Trade expenditure" },
        ],
      },
    ],
  });
  const [value, setValue] = React.useState(0);
  const handleChange = (e, newValue) => setValue(newValue);
  const tabs = ["Stock","GSV", "CSL"];

  useEffect(() => {
    localStorage.setItem("activeItem", null);
  }, []);

  return (
    <>
      <AuthenticatedTemplate>
        <div id="homePage">
          <Box
            className="mainLayout"
            sx={{ display: "flex", overflow: "hidden" }}
          >
            <MainLayout />
            <Box component="main" sx={{ flexGrow: 1 }}>
              <DrawerHeader />

              <div id="">
                <Box className="w-full">
                  <Box className="border-b border-gray-300 ml-2">
                    <Tabs
                      value={value}
                      onChange={handleChange}
                      className="mt-4"
                      TabIndicatorProps={{ style: { display: "none" } }}
                    >
                      {tabs.map((label, index) => (
                        <Tab
                          key={label}
                          label={label}
                          className={`text-sm capitalize font-medium transition-all duration-200 `}
                          sx={{
                            minHeight: "40px",
                            padding: "8px 16px",
                            backgroundColor:
                              value === index ? "#1d64ac" : "#eee",
                            color:
                              value === index ? "#ffffff !important" : "#000",
                            borderRadius: "4px",
                            marginRight: "8px",
                          }}
                        />
                      ))}
                    </Tabs>
                  </Box>

                  <CustomTabPanel value={value} index={0}>
                    <Flowchart graphData={stoke} />
                  </CustomTabPanel>
                 
                  <CustomTabPanel value={value} index={1}>
                    <Flowchart graphData={gsv} />
                  </CustomTabPanel>

                  <CustomTabPanel value={value} index={2}>
                    <Flowchart graphData={csldata} />
                  </CustomTabPanel>

                 
                </Box>
              </div>
            </Box>
          </Box>
        </div>
      </AuthenticatedTemplate>

      <UnauthenticatedTemplate>
        <Login />
      </UnauthenticatedTemplate>
    </>
  );
};

export default KnowledgeGraph;
